import { render, staticRenderFns } from "./VirtualScrollHorizontal.vue?vue&type=template&id=8ddd8114&scoped=true"
import script from "./VirtualScrollHorizontal.vue?vue&type=script&lang=ts"
export * from "./VirtualScrollHorizontal.vue?vue&type=script&lang=ts"
import style0 from "./VirtualScrollHorizontal.vue?vue&type=style&index=0&id=8ddd8114&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ddd8114",
  null
  
)

export default component.exports